<template>
  <router-link
    :to="{ name: 'Order', params: { order: orders.Guid } }"
    class="order-card"
    data-num="orders"
    :orders="orders"
  >
    <div class="order-card-wrapper">
      <div class="order-card__header">
        <div class="order-card__header-info">
          <div class="order-card__header-info__icon">
            <svg
              width="16"
              height="18"
              viewBox="0 0 16 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.3069 5.7885C13.9514 5.22548 12.4949 5.14019 11.0948 5.54174L9.27538 6.06357L4.12052 2.73881C4.01458 2.6705 3.88924 2.65127 3.77083 2.6852L1.60562 3.3062C1.43068 3.3564 1.29681 3.51488 1.26115 3.71401C1.22553 3.9131 1.29446 4.11753 1.43856 4.23994L5.02105 7.2838L3.54586 7.70691L1.51352 6.35139C1.29893 6.20827 1.02224 6.27886 0.883526 6.51223L0.079246 7.8655C-0.0427225 8.0707 -0.0221288 8.34355 0.128808 8.52271L2.56049 11.409C2.65033 11.5157 2.77415 11.574 2.90143 11.574C2.94008 11.574 2.97902 11.5686 3.01746 11.5576L15.2017 8.06311C15.661 7.93134 15.9738 7.50202 15.9984 6.9694C16.0231 6.43675 15.7517 5.97325 15.3069 5.7885Z"
                fill="black"
              />
              <path
                d="M8.09117 14.2743H0.469718C0.210312 14.2743 0 14.5109 0 14.8028C0 15.0946 0.210312 15.3312 0.469718 15.3312H8.09114C8.35055 15.3312 8.56086 15.0946 8.56086 14.8028C8.56086 14.5109 8.35058 14.2743 8.09117 14.2743Z"
                fill="black"
              />
            </svg>
          </div>
          <div class="order-card__header-info__category">Авиаперелет</div>
          <div class="order-card__header-info__number">№ {{ orders.Id }}</div>
        </div>
        <div class="order-card__header-status">
          <div
            class="order-card__header-status__wrapper"
            v-if="orders.State == 40"
          >
            <div class="order-card__header-status__icon">
              <svg
                class="icon_yellow"
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <ellipse cx="4" cy="3.5" rx="4" ry="3.5" fill="darkorange" />
              </svg>
            </div>
            <div class="order-card__header-status__text">Забронирован</div>
          </div>
          <div
            class="order-card__header-status__wrapper"
            v-else-if="orders.State == 60"
          >
            <div class="order-card__header-status__icon">
              <svg
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <ellipse cx="4" cy="3.5" rx="4" ry="3.5" fill="#6BC242" />
              </svg>
            </div>
            <div class="order-card__header-status__text">Оформлен</div>
          </div>
          <div
            class="order-card__header-status__wrapper"
            v-else-if="orders.State == 55 || orders.State == 65"
          >
            <div class="order-card__header-status__icon">
              <svg
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <ellipse cx="4" cy="3.5" rx="4" ry="3.5" fill="#6BC242" />
              </svg>
            </div>
            <div class="order-card__header-status__text">Обрабатывается</div>
          </div>
          <div
            class="order-card__header-status__wrapper"
            v-else-if="
              orders.State == 70 ||
              orders.State == 71 ||
              orders.State == 72 ||
              orders.State == 73 ||
              orders.State == 74
            "
          >
            <div class="order-card__header-status__icon">
              <svg
                class="icon_red"
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <ellipse cx="4" cy="3.5" rx="4" ry="3.5" fill="red" />
              </svg>
            </div>
            <div class="order-card__header-status__text">Отменён</div>
          </div>
        </div>
      </div>
      <div class="order-card__footer">
        <div class="order-card__footer-depdate__wrapper">
          <div class="order-card__footer-depdate">
            <div v-if="orders.DepInfo.backDate == null">
              <span class="order-card__footer-depdate__date">{{
                getDate(orders.DepInfo.depDate)
              }}</span
              >,&nbsp;<span class="order-card__footer-depdate__week">{{
                getWeekDay(orders.DepInfo.depDate)
              }}</span>
            </div>
            <div v-else>
              <span class="order-card__footer-depdate__date">{{
                getDate(orders.DepInfo.depDate)
              }}</span
              >,&nbsp;<span class="order-card__footer-depdate__week">{{
                getWeekDay(orders.DepInfo.depDate)
              }}</span>
              <span class="order-card__footer-depdate__tire"
                >&nbsp;&nbsp;-&nbsp;&nbsp;</span
              >
              <span class="order-card__footer-backdate__date">{{
                getDate(orders.DepInfo.backDate)
              }}</span
              >,&nbsp;<span class="order-card__footer-backdate__week">{{
                getWeekDay(orders.DepInfo.backDate)
              }}</span>
            </div>
          </div>
          <div class="order-card__footer-passengers">
            {{
              orders.PassengersCount +
              " " +
              declOfNum(orders.PassengersCount, this.words)
            }}
          </div>
        </div>
        <div class="order-card__footer-route__wrapper">
          <div class="order-card__footer-route">
            <div class="order-card__footer-route__dep">
              {{ wordWraper(orders.DepInfo.depCity) }}
            </div>

            <div class="order-card__footer-route__icon">
              <div v-if="orders.DepInfo.backDate == null">
                <svg
                  width="15"
                  height="11"
                  viewBox="0 0 15 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.535 4.73432L9.8475 1.63988C9.27 1.25901 8.38031 1.29201 7.86094 1.71688C7.34156 2.13969 7.38844 2.79213 7.96594 3.173L9.92813 4.46894H1.40625C0.629063 4.46894 0 4.93025 0 5.50019C0 6.07013 0.629063 6.53144 1.40625 6.53144H9.93L7.965 7.82738C7.3875 8.20894 7.34062 8.86069 7.86 9.2835C8.13844 9.50969 8.52188 9.62519 8.90625 9.62519C9.24188 9.62519 9.57844 9.53788 9.84656 9.3605L14.5341 6.26744C14.8303 6.07219 15 5.79307 15 5.50088C15 5.20869 14.8303 4.92957 14.535 4.73432Z"
                    fill="black"
                  />
                </svg>
              </div>
              <div v-else>
                <svg
                  width="15"
                  height="10"
                  viewBox="0 0 15 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0)">
                    <path
                      d="M0.429547 6.61373C0.258895 6.73633 0.143637 6.9046 0.123602 7.077C0.103581 7.25144 0.163119 7.43101 0.30087 7.57616C0.337807 7.61575 0.381823 7.65331 0.428699 7.68682L0.430134 7.68783L3.34071 9.76835C3.75692 10.0659 4.43203 10.0664 4.84872 9.76954C5.2654 9.47268 5.26578 8.99091 4.84957 8.6934L3.75721 7.91258L12.8109 7.91973C13.3993 7.9202 13.8771 7.57977 13.8774 7.15988C13.8778 6.73998 13.4005 6.39881 12.8121 6.39834L3.75841 6.39119L4.88045 5.59183C5.29712 5.29498 5.2975 4.8132 4.8813 4.5157C4.46508 4.21818 3.78996 4.21764 3.37329 4.5145L0.429549 6.6117C0.430983 6.61272 0.429548 6.61271 0.429547 6.61373Z"
                      fill="black"
                    />
                    <path
                      d="M8.81021 0.767392C8.81005 0.96213 8.91365 1.15695 9.12247 1.3052L10.2432 2.10633L1.18958 2.09918C0.601167 2.09872 0.123342 2.43913 0.123011 2.85904C0.122679 3.27894 0.599965 3.62011 1.18838 3.62057L10.242 3.62773L9.14844 4.40682C8.94082 4.55475 8.83549 4.74939 8.83533 4.94413C8.83518 5.13887 8.93878 5.33369 9.14759 5.48193C9.5638 5.77944 10.2389 5.77998 10.6556 5.48313C10.7324 5.42843 10.8106 5.3727 10.8874 5.31798C11.0765 5.18324 11.2671 5.04951 11.4548 4.91374C11.698 4.73949 11.9412 4.56623 12.1858 4.393C12.4275 4.22279 12.6622 4.0465 12.9068 3.87731C13.1428 3.71319 13.3746 3.54703 13.5965 3.37175C13.8269 3.18936 13.9408 2.9511 13.86 2.70559C13.8401 2.64269 13.8061 2.57572 13.762 2.51889C13.6286 2.3494 13.4084 2.21433 13.218 2.07725C12.9865 1.90972 12.7507 1.74522 12.5163 1.5787C12.2379 1.3807 11.9609 1.18067 11.6839 0.981653C11.4481 0.815128 11.2123 0.646574 10.9765 0.479035C10.8628 0.397804 10.7506 0.316575 10.637 0.235344C10.6356 0.234329 10.6327 0.232298 10.6313 0.231282C10.2151 -0.0662248 9.53999 -0.066758 9.12332 0.230091C8.91427 0.377998 8.81036 0.572654 8.81021 0.767392Z"
                      fill="black"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect
                        width="9.98895"
                        height="13.9976"
                        fill="white"
                        transform="translate(14.0055 0.0110474) rotate(90.0453)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
            <div class="order-card__footer-route__arr">
              {{ wordWraper(orders.DepInfo.destCity) }}
            </div>
          </div>
          <div class="order-card__footer-route__company">
            {{ orders.DepInfo.airlines }}
          </div>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script lang="ts">
import { defineComponent, watchEffect } from "vue";

export default defineComponent({
  name: "OrderCard",
  props: ["orders"],

  data() {
    return {
      words: ["пассажир", "пассажира", "пассажиров"],
      activeOrder: null,
    };
  },
  methods: {
    getWeekDay(date: any) {
      let days = ["вс", "пн", "вт", "ср", "чт", "пт", "сб"];
      let weekDay = new Date(date);
      return days[weekDay.getDay()];
    },
    getDate(date: any) {
      let month = [
        "Января",
        "Февраля",
        "Марта",
        "Апреля",
        "Мая",
        "Июня",
        "Июля",
        "Августа",
        "Сентября",
        "Октября",
        "Ноября",
        "Декабря",
      ];
      let monthNum = new Date(date);
      return monthNum.getDate() + " " + month[monthNum.getMonth()];
    },
    declOfNum(number: any, words: any) {
      return words[
        number % 100 > 4 && number % 100 < 20
          ? 2
          : [2, 0, 1, 1, 1, 2][number % 10 < 5 ? Math.abs(number) % 10 : 5]
      ];
    },
    wordWraper(word: string): string {
      const position = word.indexOf("(");
      if (position !== -1) {
        const newWord = word.slice(0, position);
        return newWord;
      } else {
        return word;
      }
    },
  },
  created() {
    watchEffect(() => {
      this.activeOrder = this.orders;
    });
  },
});
</script>

<style>
@media screen and (max-width: 767px) {
  .order-card {
    display: block;
    text-decoration: none;
    margin-top: 20px;
    background-color: #fff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 3px;
    overflow: hidden;
    color: inherit;
  }

  .order-card__header {
    padding-bottom: 8px;
    border-bottom: 1px solid #8f8f8f;
  }

  .order-card__header-info {
    margin: 10px 0 0 20px;
    display: flex;
    align-items: center;
  }

  .order-card__header-info__category {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    margin-left: 10px;
    margin-bottom: 4px;
  }

  .order-card__header-info__number {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    margin-left: 10px;
    color: #939090;
    margin-bottom: 4px;
  }

  .order-card__header-status {
    margin-left: 23px;
    display: flex;
    align-items: center;
  }
  .order-card__header-status__wrapper {
    display: flex;
    align-items: center;
  }

  .order-card__header-status__icon {
    padding-bottom: 3px;
  }

  .icon_yellow {
    fill: darkorange;
  }
  .icon_red {
    fill: red;
  }

  .order-card__header-status__text {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: #939090;
    margin-left: 14px;
  }

  .order-card__footer {
    margin-left: 20px;
    padding-bottom: 15px;
  }

  .order-card__footer-depdate {
    display: flex;
    margin-top: 12px;
  }
  .order-card__footer-depdate__date {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
  }

  .order-card__footer-depdate__week {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: #939090;
  }

  .order-card__footer-backdate__date {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
  }

  .order-card__footer-backdate__week {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: #939090;
  }

  .order-card__footer-passengers {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: #939090;
  }

  .order-card__footer-route {
    margin-top: 10px;
    display: flex;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    align-items: center;
  }

  .order-card__footer-route__dep {
    max-width: 50%;
  }

  .order-card__footer-route__icon {
    margin: 2px 8px 0 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .order-card__footer-route__company {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: #939090;
  }
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  .order-card {
    display: block;
    text-decoration: none;
    margin-top: 20px;
    background-color: #fff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 3px;
    overflow: hidden;
    color: inherit;
  }

  .order-card__header {
    padding-top: 5px;
    padding-bottom: 8px;
    padding-right: 10px;
    border-bottom: 1px solid #8f8f8f;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .order-card__header-info {
    margin: 10px 0 0 20px;
    display: flex;
  }

  .order-card__header-info__category {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    margin-left: 10px;
  }

  .order-card__header-info__number {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    margin-left: 10px;
    color: #939090;
  }

  .order-card__header-status {
    display: flex;
    align-items: center;
  }
  .order-card__header-status__wrapper {
    display: flex;
    align-items: center;
  }

  .order-card__header-status__icon {
    padding-bottom: 3px;
    margin-right: 5px;
  }

  .icon_yellow {
    fill: darkorange;
  }
  .icon_red {
    fill: red;
  }

  .order-card__header-status__text {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    color: #939090;
  }

  .order-card__footer {
    margin-left: 20px;
    padding-bottom: 15px;
    display: flex;
    align-items: center;
  }

  .order-card__footer-depdate__wrapper {
    margin-top: 15px;
    width: 37%;
  }

  .order-card__footer-depdate {
    display: flex;
  }
  .order-card__footer-depdate__date {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
  }

  .order-card__footer-depdate__week {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    color: #939090;
  }

  .order-card__footer-backdate__date {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
  }

  .order-card__footer-backdate__week {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    color: #939090;
  }

  .order-card__footer-passengers {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    color: #939090;
    margin-top: 5px;
  }

  .order-card__footer-route__wrapper {
    margin-top: 15px;
    max-width: 55%;
  }

  .order-card__footer-route {
    display: flex;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    align-items: center;
  }

  .order-card__footer-route__icon {
    margin: 2px 8px 0 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .order-card__footer-route__company {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    color: #939090;
    margin-top: 5px;
  }
}

@media screen and (min-width: 1025px) {
  .order-card {
    display: block;
    text-decoration: none;
    margin-top: 20px;
    background-color: #fff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 3px;
    overflow: hidden;
    color: inherit;
  }

  .order-card__header {
    padding-top: 5px;
    padding-bottom: 8px;
    padding-right: 10px;
    border-bottom: 1px solid #8f8f8f;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .order-card__header-info {
    margin: 10px 0 0 20px;
    display: flex;
  }

  .order-card__header-info__category {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    margin-left: 10px;
  }

  .order-card__header-info__number {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    margin-left: 10px;
    color: #939090;
  }

  .order-card__header-status {
    display: flex;
    align-items: center;
  }
  .order-card__header-status__wrapper {
    display: flex;
    align-items: center;
  }

  .order-card__header-status__icon {
    padding-bottom: 3px;
    margin-right: 5px;
  }

  .icon_yellow {
    fill: darkorange;
  }
  .icon_red {
    fill: red;
  }

  .order-card__header-status__text {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    color: #939090;
  }

  .order-card__footer {
    margin-left: 20px;
    padding-bottom: 15px;
    display: flex;
    align-items: center;
  }

  .order-card__footer-depdate__wrapper {
    margin-top: 15px;
    width: 37%;
  }

  .order-card__footer-depdate {
    display: flex;
  }
  .order-card__footer-depdate__date {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
  }

  .order-card__footer-depdate__week {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    color: #939090;
  }

  .order-card__footer-backdate__date {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
  }

  .order-card__footer-backdate__week {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    color: #939090;
  }

  .order-card__footer-passengers {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    color: #939090;
    margin-top: 5px;
  }

  .order-card__footer-route__wrapper {
    margin-top: 15px;
    max-width: 55%;
  }

  .order-card__footer-route {
    display: flex;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    align-items: center;
  }

  .order-card__footer-route__icon {
    margin: 2px 8px 0 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .order-card__footer-route__company {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    color: #939090;
    margin-top: 5px;
  }
}
</style>
